import type { CoreProjection } from '../../_contract/config';
import { toInnermostBoundaryKind, type VisualNode } from '../projection';

export function collectPackageTree(projection: CoreProjection): VisualNode[] {
    const packages = projection.children.packages;
    if (!packages || packages.nodeKind !== 'directory') {
        throw new Error('Core package visualization requires a packages directory.');
    }
    const packageEntries = Object.entries(packages.children)
        .filter(([, node]) => node.nodeKind === 'directory')
        .sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0);
    const nodes: VisualNode[] = [{
        nodeKind: 'directory', name: 'core/', path: '.', parentPath: null, depth: 0,
        childPaths: packageEntries.map(([, node]) => node.path), boundaryKind: null,
    }];
    const pending: { parent: VisualNode; source: CoreProjection['children'][string] }[] = [];
    for (const [name, source] of packageEntries) {
        const node: VisualNode = { nodeKind: 'directory', name, path: source.path, parentPath: '.', depth: 1,
            childPaths: [], boundaryKind: null };
        nodes.push(node);
        if (source.nodeKind === 'directory' && source.children.src?.nodeKind === 'directory') {
            pending.push({ parent: node, source: source.children.src });
        }
    }
    for (let cursor = 0; cursor < pending.length; cursor++) {
        const { parent, source } = pending[cursor]!;
        if (source.nodeKind !== 'directory') continue;
        const children = Object.entries(source.children).sort(([aName, a], [bName, b]) =>
            a.nodeKind !== b.nodeKind ? (a.nodeKind === 'directory' ? -1 : 1)
                : aName < bName ? -1 : aName > bName ? 1 : 0);
        for (const [name, child] of children) {
            const node: VisualNode = { nodeKind: child.nodeKind, name, path: child.path,
                parentPath: parent.path, depth: parent.depth + 1, childPaths: [],
                boundaryKind: toInnermostBoundaryKind(child.path) };
            parent.childPaths.push(node.path);
            nodes.push(node);
            if (child.nodeKind === 'directory') pending.push({ parent: node, source: child });
        }
    }
    return nodes;
}
